import { AssignableRole, DashboardUserRole } from '@/domain/dashboard-user'

export type WarehouseOption = {
  id: string
  label: string
}

type RoleOption = {
  value: AssignableRole
  labelKey: string
  descriptionKey: string
}

export const ROLE_OPTIONS: RoleOption[] = [
  {
    value: 'ADMIN',
    labelKey: 'dashboard_users.role_admin',
    descriptionKey: 'dashboard_users.role_admin_description'
  },
  {
    value: 'READ_ONLY',
    labelKey: 'dashboard_users.role_read_only',
    descriptionKey: 'dashboard_users.role_read_only_description'
  },
  {
    value: 'REVIEWER',
    labelKey: 'dashboard_users.role_reviewer',
    descriptionKey: 'dashboard_users.role_reviewer_description'
  },
  {
    value: 'ANALYTICS_ONLY',
    labelKey: 'dashboard_users.role_analytics_only',
    descriptionKey: 'dashboard_users.role_analytics_only_description'
  }
]

export const DEFAULT_ROLE: AssignableRole = 'READ_ONLY'

export function roleLabelKey(role: DashboardUserRole) {
  return (
    ROLE_OPTIONS.find((option) => option.value === role)?.labelKey ??
    'dashboard_users.role_unknown'
  )
}

export function roleDescriptionKey(role: AssignableRole) {
  return (
    ROLE_OPTIONS.find((option) => option.value === role)?.descriptionKey ?? ''
  )
}

export function warehouseLabel(warehouses: WarehouseOption[], id: string) {
  return warehouses.find((warehouse) => warehouse.id === id)?.label ?? id
}
